export default __webpack_public_path__ + "static/media/care-diary.c40d6cbe.png";